/**
 * Keep --app-height in sync with the visible viewport.
 *
 * Mobile browsers (iPad Safari/Chrome via WebKit) change the visible height when
 * the address/toolbar chrome shows or hides. CSS 100vh does not track that, which
 * leaves a gap or overflow under the app shell. visualViewport does.
 *
 * CSS should fall back with:
 *   --app-height: 100vh; --app-height: 100dvh;
 */

const APP_HEIGHT_VAR = '--app-height';

export function readVisibleViewportHeight(win = window) {
  const visualViewportHeight = win.visualViewport?.height;

  if (typeof visualViewportHeight === 'number' && visualViewportHeight > 0) {
    return visualViewportHeight;
  }

  return win.innerHeight;
}

export function syncAppHeight(doc = document, win = window) {
  const height = readVisibleViewportHeight(win);
  doc.documentElement.style.setProperty(APP_HEIGHT_VAR, `${height}px`);

  return height;
}

export function startAppHeightSync(doc = document, win = window) {
  const update = () => syncAppHeight(doc, win);

  update();

  win.addEventListener('resize', update);

  const visualViewport = win.visualViewport;
  if (visualViewport) {
    visualViewport.addEventListener('resize', update);
    visualViewport.addEventListener('scroll', update);
  }

  return () => {
    win.removeEventListener('resize', update);

    if (visualViewport) {
      visualViewport.removeEventListener('resize', update);
      visualViewport.removeEventListener('scroll', update);
    }
  };
}
